import {Icon, Icons} from "./icon";

export class MapSettings {
    points: { x: number, y: number, z: number }[]
    curves: number[][][] = [];
    constructor(data?: MapSettings ) {
        this.points = data?.points ?? [];
        this.curves = data?.curves ?? [];
    }
}

export const MapPoints:  {
    x: number
    y: number
    z: number
}[] = [
    {x: -6.90, y: 1.00, z: 0.2}
    // {x: -0.6978823537269812, y: 0.5120368494962872, z: 1},
    // {x: -4.290243870381092, y: 0.5165913557629849, z: 1}
];


export const MapCurves: number[][][] = [

];


export class MapIcon {
    id?: number;
    icon?: Icon;
    title?: string;
    name: string;
    active?: boolean = false;
    constructor(data: MapIcon) {
        this.id = data.id;
        this.icon = data.icon;
        this.title = data.title;
        this.name = data.name;
        this.active = data.active;
    }
}

export const MapIcons: MapIcon[] = [
    {
        id: 0,
        title: 'Все места',
        name: 'all',
    },
    {
        id: 1,
        icon: Icons.star,
        title: 'Трудовой подвиг',
        name: 'star',
    },
    {
        id: 2,
        icon: Icons.target,
        title: 'Боевые действия',
        name: 'target',
    },
    {
        id: 3,
        icon: Icons.bomb,
        title: 'Бомбардировки',
        name: 'bomb',
    },
    {
        id: 4,
        icon: Icons.medal,
        title: 'Боевой подвиг',
        name: 'medal',
    },
    {
        id: 5,
        icon: Icons.train,
        title: 'Строительство бронепоезда',
        name: 'train',
    },
    {
        id: 6,
        icon: Icons.fist,
        title: 'Будни ЖД',
        name: 'fist',
    },
    {
        id: 7,
        icon: Icons.attention,
        title: 'Нарушения в работе',
        name: 'attention',
    },
    {
        id: 8,
        icon: Icons.evacuation,
        title: 'Эвакуация',
        name: 'evacuation',
    },
    {
        id: 9,
        icon: Icons.crane,
        title: 'Развитие инфраструктуры',
        name: 'crane',
    },
    {
        id: 10,
        icon: Icons.gear,
        title: 'Восстановительный поезд',
        name: 'gear',
    },
    {
        id: 10,
        icon: Icons.helmet,
        title: 'Колонны особого резерва',
        name: 'helmet',
    },
    {
        id: 10,
        icon: Icons.ashoka,
        title: 'Спец.вагоны',
        name: 'ashoka',
    },
    {
        id: 11,
        icon: Icons.panorama,
        title: 'Панорамы',
        name: 'panorama',
    },
];